type CacheEntry<T> = {
  data: T;
  expiresAt: number;
};

const DEFAULT_TTL_MS = 5 * 60 * 1000;

class AppCache {
  private store = new Map<string, CacheEntry<unknown>>();

  get<T>(key: string): T | null {
    const entry = this.store.get(key);
    if (!entry) return null;
    if (Date.now() >= entry.expiresAt) {
      this.store.delete(key);
      return null;
    }
    return entry.data as T;
  }

  set<T>(key: string, data: T, ttlMs: number = DEFAULT_TTL_MS): void {
    this.store.set(key, { data, expiresAt: Date.now() + ttlMs });
  }

  has(key: string): boolean {
    return this.get(key) !== null;
  }

  invalidate(pattern: string): void {
    const regex = new RegExp(
      '^' + pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$'
    );
    for (const key of Array.from(this.store.keys())) {
      if (regex.test(key)) this.store.delete(key);
    }
  }

  invalidateMany(patterns: string[]): void {
    patterns.forEach((p) => this.invalidate(p.trim()));
  }

  clear(): void {
    this.store.clear();
  }
}

export const appCache = new AppCache();
export default appCache;